import { Box, Button, Typography } from "@mui/material";
import styles from "../styles";
import { useNavigate } from "react-router-dom";

const JoinCompetition = () => {
    const navigate = useNavigate();
    return (
        <Box sx={styles.winProbabilityBox}>
            <Box sx={styles.referralWinnerContainer}>
                <Box sx={styles.referralWinnerBg}>
                    <Box sx={styles.referralTextContainer}>
                        <Typography sx={styles.referralText}>
                            Get A chance to win
                        </Typography>
                        <Typography sx={styles.referralText}>
                            At the top
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        sx={styles.referralButton}
                        onClick={() => navigate("/draw")}
                    >
                        Participate Now
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default JoinCompetition;